import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      {/* Header */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0f]/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <button 
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </button>
        </div>
      </nav>

      {/* Content */}
      <div className="pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold font-['Unbounded'] mb-2">Privacy Policy</h1>
          <p className="text-gray-500 mb-12">Last updated: April 2026</p>

          <div className="space-y-8 text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">1. Information We Collect</h2>
              <p className="mb-4">We collect information you provide directly to us, including:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-400">
                <li>Account information (name, email, password)</li>
                <li>Business details (company name, website)</li>
                <li>Creator profile information (platforms, niches, audience data)</li>
                <li>Payment information (processed securely via Stripe)</li>
                <li>Campaign data and performance metrics</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">2. How We Use Your Information</h2>
              <p className="mb-4">We use the information we collect to:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-400">
                <li>Provide, maintain, and improve our services</li>
                <li>Process transactions and send related information</li>
                <li>Match businesses with relevant creators</li>
                <li>Track campaign performance (clicks, leads, customers)</li>
                <li>Send technical notices, updates, and support messages</li>
                <li>Respond to your comments, questions, and requests</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">3. Campaign Tracking</h2>
              <p>
                Our platform tracks campaign results including clicks, leads, and customer conversions. 
                This tracking is essential for our performance-based payment model. We use unique 
                tracking links to attribute results to specific creators. This data is used solely 
                for campaign analytics and payment calculations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">4. Payment Processing</h2>
              <p>
                All payment processing is handled by Stripe. We do not store your complete credit card 
                information on our servers. Stripe's use of your personal information is governed by 
                their Privacy Policy. Creator payouts are processed through Stripe Connect.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">5. Data Sharing</h2>
              <p className="mb-4">We do not sell your personal information. We may share information with:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-400">
                <li>Service providers who assist in our operations (Stripe, cloud hosting)</li>
                <li>Business partners for campaign matching (limited profile data)</li>
                <li>Law enforcement when required by law</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">6. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal 
                information against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">7. Your Rights</h2>
              <p className="mb-4">You have the right to:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-400">
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Export your data</li>
                <li>Opt out of marketing communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">8. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at 
                privacy@elektrouniversal.dk
              </p>
            </section>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-white/5 py-8 px-6">
        <div className="max-w-4xl mx-auto text-center text-sm text-gray-600">
          © 2026 EleKtro Universal. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
